class archiveList {
	constructor() {
			//this.pageReload();
			this.listPagination();
			this.categoryFilter();
			this.postSearchFilter();
			this.resetFilter();
	}

	setURLParameter(value) {
			var queryParams = new URLSearchParams(window.location.search);
			queryParams.delete('pages');
			queryParams.set("p-type", value);
			if (typeof value !== 'undefined')
				history.pushState(null, null, "?" + queryParams.toString());
			else
				history.pushState(null, null,location.protocol + "//" + location.host + location.pathname);
	}

	setParameter(key, value){
		var queryParams = new URLSearchParams(window.location.search);
		queryParams.set(key, value);
		if (typeof value !== 'undefined')
			history.pushState(null, null, "?" + queryParams.toString());
		else
			history.pushState(null, null,location.protocol + "//" + location.host + location.pathname);
	}

	deleteParameter(key) {
		var queryParams = new URLSearchParams(window.location.search);
		queryParams.delete(key);

		history.pushState(null, null, "?" +queryParams.toString());
	}

	getUrlParameter(value) {
			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			return urlParams.get(value);
	}

	getAllUrlStringParams(url) {

			// get query string from url (optional) or window
			var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

			// we'll store the parameters here
			var obj = {};

			// if query string exists
			if (queryString) {

					// stuff after # is not part of query string, so get rid of it
					queryString = queryString.split('#')[0];

					// split our query string into its component parts
					var arr = queryString.split('&');

					for (var i = 0; i < arr.length; i++) {
							// separate the keys and the values
							var a = arr[i].split('=');

							// set parameter name and value (use 'true' if empty)
							var paramName = a[0];
							var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

							// (optional) keep case consistent
							paramName = paramName.toLowerCase();
							if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

							// if the paramName ends with square brackets, e.g. colors[] or colors[2]
							if (paramName.match(/\[(\d+)?\]$/)) {

									// create key if it doesn't exist
									var key = paramName.replace(/\[(\d+)?\]/, '');
									if (!obj[key]) obj[key] = [];

									// if it's an indexed array e.g. colors[2]
									if (paramName.match(/\[\d+\]$/)) {
											// get the index value and add the entry at the appropriate position
											var index = /\[(\d+)\]/.exec(paramName)[1];
											obj[key][index] = paramValue;
									} else {
											// otherwise add the value to the end of the array
											obj[key].push(paramValue);
									}
							} else {
									// we're dealing with a string
									if (!obj[paramName]) {
											// if it doesn't exist, create property
											obj[paramName] = paramValue;
									} else if (obj[paramName] && typeof obj[paramName] === 'string'){
											// if property does exist and it's a string, convert it to an array
											obj[paramName] = [obj[paramName]];
											obj[paramName].push(paramValue);
									} else {
											// otherwise add the property
											obj[paramName].push(paramValue);
									}
							}
					}
			}

			return obj;
	}

	// pageReload() {
	//     var getCatParam = this.getUrlParameter('p-type');
	//     console.log(getCatParam);
	//     if (getCatParam != null) {
	//         var catID = $("a[data-cat-slug='" + getCatParam + "']").attr("data-cat-id");
	//         console.log(catID);
	//         let ppr = $('.postfilter__val').attr('data-ppr'),
	//             postype = $('.postfilter__val').attr('data-post-type'),
	//             showCat = $('.postfilter__val').attr('show-cat'),
	//             showDate = $('.postfilter__val').attr('show-date'),
	//             currenturl = $('.postfilter__val').attr('currenturl');
	//             //console.log("pagereload: "+showCat);
	//         //this.postAjaxFilter(ppr,catID,postype,showCat,showDate);
	//         this.postAjaxFilter(ppr,catID,postype,'',showDate,showCat,currenturl, getCatParam)
	//     } else {
	//         $('.resources_category_posts').find('.featured_post').show();
	//     }
	//
	// }

	listPagination() {
			$(document).on('click', '.pagination a', (e) => {
					e.preventDefault();
					const elem = $(e.currentTarget),
							href = elem.attr('href'),
							paged =this.getAllUrlStringParams(href).pages;
					this.setParameter('pages', paged);
					const searchVal = $('.postfilter__val').attr('data-search-val');
					const postType = $('.postfilter__val').attr('data-post-type');
					const excludeCategories = $('.postfilter__val').attr('data-exclude-categories');
					const pType = this.getUrlParameter('p-type');

					if (pType != null) {
							// paging a specific category
							//console.log('/' + postType + '/?p-type=' + pType + '&paged=' + paged + '&search=' + searchVal);
							$.ajax({
									type: 'GET',
									dataType: 'html',
									url: '/' + postType + '/?p-type=' + pType + '&pages=' + paged + '&search=' + searchVal,
									success: function success(response) {
											var $entries = $('.resources_category_posts', response);
											$('.resources_category_posts').html($entries.html()).fadeIn();
									},
							});
					}else{
							// paging the All list
							const ppr = $('.postfilter__val').attr('data-ppr'),
							showCat = $('.postfilter__val').attr('show-cat'),
							showDate = $('.postfilter__val').attr('show-date'),
							currenturl = $('.postfilter__val').attr('currenturl');

							const data = {
									'ppr': ppr,
									'catID': '',
									'pages': paged,
									'postype': postType,
									'searchVal': searchVal,
									'showDate': showDate,
									'showCat': showCat,
									'currenturl': currenturl,
									'action': 'dwd_post_filter',
									'excludeCategories': excludeCategories
							}
							// console.log(data);
							$.ajax({
									url: dwd_object.ajaxurl,
									data: data,
									type: 'POST',
									success: (response) => {
											$('.resources__results').html(response.html);
											$('.pagination').html(response.pagination);
									}
							});

					}
					setTimeout(() => {
						$(window).scrollTop(0);
					}, 400);
			});
	}

	categoryFilter() {
			$(document).on('click', '.post-filter__nav_js ul li a', (e) => {
					e.preventDefault();
					$('.post-filter__nav_js ul li').removeClass('active');
					const elem = $(e.currentTarget),
							catID = elem.attr('data-cat-id'),
							catSlug = elem.attr('data-cat-slug');
					this.setURLParameter(catSlug);

					const ppr = $('.postfilter__val').attr('data-ppr'),
							//catName = $('.postfilter__val').attr('data-cat-id'),
							postype = $('.postfilter__val').attr('data-post-type'),
							searchVal = $('.postfilter__val').attr('data-search-val'),
							showCat = $('.postfilter__val').attr('show-cat'),
							showDate = $('.postfilter__val').attr('show-date'),
							currenturl = $('.postfilter__val').attr('currenturl'),
							excludeCategories = $('.postfilter__val').attr('data-exclude-categories');

					$('.postfilter__val').attr('data-page-num', 1);
					$('.postfilter__val').attr('data-cat-id', catID);


					elem.parent().addClass('active');

					this.postAjaxFilter(ppr,catID,postype,searchVal,showDate,showCat,currenturl,catSlug,excludeCategories);
			});
	}

	postSearchFilter() {
			$(document).on('keypress', '.search-filter__js', (e) => {
					if (e.code == 'Enter') {
							var elem = $(e.currentTarget),
									searchVal = elem.val();
							this.deleteParameter('pages');
							this.setParameter('search', searchVal);
							//console.log("here: "+searchVal)
							$('.postfilter__val').attr('data-search-val', searchVal);
							if( searchVal != ''){
									$('.form-search .form-search-reset').parents('.form-group').toggleClass('searched');
							}
							let ppr = $('.postfilter__val').attr('data-ppr'),
									postype = $('.postfilter__val').attr('data-post-type'),
									catID = $('.postfilter__val').attr('data-cat-id'),
									showCat = $('.postfilter__val').attr('show-cat'),
									showDate = $('.postfilter__val').attr('show-date'),
									currenturl = $('.postfilter__val').attr('currenturl');
									//console.log(catID);

							this.postAjaxFilter(ppr,catID,postype,searchVal,showDate,showCat,currenturl,catID);
					}
			});
			$(document).on('click', '.form-search-submit', (e) => {
					var searchVal = $('.search-filter__js').val();
					if( searchVal != ''){
							this.deleteParameter('pages');
							this.setParameter('search', searchVal);
							//console.log("here: "+searchVal)
							$('.postfilter__val').attr('data-search-val', searchVal);

									$('.form-search .form-search-reset').parents('.form-group').toggleClass('searched');
							let ppr = $('.postfilter__val').attr('data-ppr'),
									postype = $('.postfilter__val').attr('data-post-type'),
									catID = $('.postfilter__val').attr('data-cat-id'),
									showCat = $('.postfilter__val').attr('show-cat'),
									showDate = $('.postfilter__val').attr('show-date'),
									currenturl = $('.postfilter__val').attr('currenturl');
									//console.log(catID);
							this.postAjaxFilter(ppr,catID,postype,searchVal,showDate,showCat,currenturl,catID);
					}
			});
	}

	resetFilter() {
			$(document).on('click', '.reset__js', () => {
					$('.search-filter__js').val('');
					$('.postfilter__val').attr('data-search-val', '');
					$('.form-search .form-search-reset').parents('.form-group').toggleClass('searched');
					this.deleteParameter('search');
					let ppr = $('.postfilter__val').attr('data-ppr'),
							postype = $('.postfilter__val').attr('data-post-type'),
							catID = $('.postfilter__val').attr('data-cat-id'),
							showCat = $('.postfilter__val').attr('show-cat'),
							showDate = $('.postfilter__val').attr('show-date'),
							currenturl = $('.postfilter__val').attr('currenturl');
							//console.log(catID);
							$('.resources__results-count').html('');
					//this.postAjaxFilter(ppr,catID,postype,showCat,showDate)
					this.postAjaxFilter(ppr,catID,postype,'',showDate,showCat,currenturl,catID)
			});
	}

	postAjaxFilter(ppr,catID,postype,searchVal='',showDate='',showCat='',currenturl='', catslug='', excludeCategories='')
	{
			const data = {
					'ppr': ppr,
					'catID': catID,
					'pages': 1,
					'postype': postype,
					'search': searchVal,
					'showDate': showDate,
					'showCat': showCat,
					'currenturl': currenturl,
					'ptype': catslug,
					'action': 'dwd_post_filter',
					'excludeCategories': excludeCategories
			}

			$.ajax({
					url: dwd_object.ajaxurl,
					data: data,
					type: 'POST',
					success: (response) => {
							$('.resources__results').html(response.html);
							$('.pagination').html(response.pagination);
					}
			});
	}

}

new archiveList();
